import { render, staticRenderFns } from "./vehicleAccidentEdit.vue?vue&type=template&id=5d92de2b&scoped=true"
import script from "./vehicleAccidentEdit.vue?vue&type=script&lang=js"
export * from "./vehicleAccidentEdit.vue?vue&type=script&lang=js"
import style0 from "./vehicleAccidentEdit.vue?vue&type=style&index=0&id=5d92de2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d92de2b",
  null
  
)

export default component.exports